import React from "react";
import styled from "styled-components";

export const RadioWrapper = styled.div`
	display: flex;
`;

const Mark = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	border: 1px solid #777777;
	width: 14px;
	height: 14px;
	left: 0;
	border-radius: 100px;
	margin-right: 5px;
	vertical-align: middle;
	&::after {
		content: "";
		display: block;
		width: 0;
		height: 0;
		border-radius: 100px;
		background-color: ${({ bgColor, theme }) => (bgColor ? bgColor : theme.colors.primary)};
		opacity: 0;
		transition: all 110ms;
	}
`;

const Input = styled.input`
	position: absolute;
	visibility: hidden;
	display: none;
	&:checked + ${Mark} {
		&::after {
			width: 10px;
			height: 10px;
			opacity: 1;
		}
	}
`;

const Label = styled.label`
	display: flex;
	cursor: pointer;
	padding: 5px 10px 5px 0;
	align-items: center;
	position: relative;
	${(props) =>
		props.disabled &&
		`
        cursor: not-allowed;
        opacity: 0.4;
    `}
`;

export const RadioButton = ({ name, label, register, validate, defaultItem }) => {
	return (
		<RadioWrapper>
			<Label>
				<Input defaultChecked={defaultItem} name={name} type="radio" />
				<Mark />
				{label}
			</Label>
		</RadioWrapper>
	);
};
